import { render, staticRenderFns } from "./Aging.vue?vue&type=template&id=32129a86&scoped=true"
import script from "./Aging.vue?vue&type=script&lang=js"
export * from "./Aging.vue?vue&type=script&lang=js"
import style0 from "./Aging.vue?vue&type=style&index=0&id=32129a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32129a86",
  null
  
)

export default component.exports